import React from 'react';

import _ from 'lodash';

import { useGetAdminFlaggedCodesQuery } from '../../../apis/AdminApi';
import { SelectorType } from '../../../types/SelectorType';
import { CurrentUser, User } from '../../../types/User';

import SavedCodeCellAdmin from './SavedCodeCellAdmin';

type Props = {
  user: CurrentUser | User;
  type: 'florence' | 'admin';
  renderLoadingSpinner: () => JSX.Element;
  renderNoRecordsText: (type: SelectorType) => JSX.Element;
};

const FlaggedCodesContainer: React.FC<Props> = ({
  user,
  type,
  renderLoadingSpinner,
  renderNoRecordsText,
}) => {
  const { data: flaggedCodes, isLoading } = useGetAdminFlaggedCodesQuery(
    user.id.toString(),
    {
      skip: type === 'florence',
      refetchOnFocus: true,
      refetchOnMountOrArgChange: 60,
    }
  );

  if (isLoading || !user) {
    return renderLoadingSpinner();
  }

  if (_.isEmpty(flaggedCodes)) {
    return renderNoRecordsText('Flagged');
  }

  return (
    <>
      {flaggedCodes?.map((code) => (
        <SavedCodeCellAdmin key={code.codeId} code={code} />
      ))}
    </>
  );
};

export default FlaggedCodesContainer;
